<template>
<div>
  <WebRTC @onPlayerSelected="onPlayerSelected"/>
  <HLS-Player :playerData="this.statis" :playerType="playerType" @onStats="onStats" @onPeerID="onPeerID" @onPeers="onPeers" />
  <Charts :lineData="lineData"/>
</div>
</template>

<script>
import Player from '../components/Player'
import Charts from '../components/Charts'
import { getQueryParam } from '@/utils/tools'
import WebRTC from '@/components/common/WebRTC.vue'

// let url = 'https://video.cdnbye.com/0cf6732evodtransgzp1257070836/e0d4b12e5285890803440736872/v.f100220.m3u8'
let url = 'https://stream.swarmcloud.net:2096/hls/sintel/playlist.m3u8'
if (location.host.includes('cdnbye.com')) {
  url = 'https://stream.cdnbye.com/hls/sintel/index.m3u8'
}
let mp4 = 'https://d2zihajmogu5jn.cloudfront.net/elephantsdream/ed_hd.mp4'
let mpd = 'https://bitmovin-a.akamaihd.net/content/MI20192708/stream.mpd'
let player = 'videojs'

export default {
  name: 'Player',
  beforeCreate() {
    player = getQueryParam('player') || player
    const param = getQueryParam('url') || undefined
    if(param) {
      // const param = search.split('?url=')[1]
      url = decodeURIComponent(param)
    } else {
      if (player === 'mp4') {
        url = mp4
      } else if (player === 'rx' || player === 'dashjs') {
        url = mpd
      }
    }

  },
  data() {
    return {
      playerType: player,
      statis: {
        url,
        offload: '0',
        ratio: '0',
        upload: '0',
        peers: '0',
        buffers: 0,
        peerID: '',
      },
      lineData: {
        series1: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
        series2: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }
    }
  },
  components: {
    Charts,
    WebRTC,
    'HLS-Player': Player
  },
  methods: {
    onPlayerSelected(type) {
      this.playerType = type;
      window.open(`${window.location.origin}${window.location.pathname}?player=${this.playerType}`, '_self')
    },
    onStats({ totalHTTPDownloaded=0, totalP2PDownloaded=0, totalP2PUploaded=0 }) {
      var total = totalHTTPDownloaded + totalP2PDownloaded
      this.statis.ratio = Math.round(totalP2PDownloaded / total * 100)
      this.statis.offload = (totalP2PDownloaded / 1024).toFixed(2)
      this.statis.upload = (totalP2PUploaded / 1024).toFixed(2)
    },
    onPeerID(id) {
      this.statis.peerID = id
    },
    onPeers(peers) {
      this.statis.peers = peers.length
    },
    onHttpDownloaded(loaded) {
      this.lineData.series1.push(loaded)
      this.lineData.series2.push(0)
      this.lineData.series1.shift()
      this.lineData.series2.shift()
    },
    onP2pDownloaded(loaded) {
      this.lineData.series2.push(loaded)
      this.lineData.series1.push(0)
      this.lineData.series1.shift()
      this.lineData.series2.shift()
    },
    onRebuffer() {
      this.statis.buffers ++
    },
  },
}
</script>
